var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebookMin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 14,
    viewBox: "0 0 7 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.18902 2.77471C5.81502 2.69991 5.3099 2.64403 4.99222 2.64403C4.13202 2.64403 4.07615 3.01802 4.07615 3.61642V4.68167H6.22642L6.03898 6.88826H4.07615V13.6H1.38379V6.88826H0L0 4.68167H1.38379V3.31678C1.38379 1.44722 2.26247 0.400024 4.46863 0.400024C5.2351 0.400024 5.7961 0.512225 6.52518 0.661825L6.18902 2.77471Z",
    fill: "#313945"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookMin);
export default __webpack_public_path__ + "static/media/facebookMin.3767ba9718e69db26d2a22356dcd79a1.svg";
export { ForwardRef as ReactComponent };